import createIcon from '../../createIcon';

/**
 * @component @name ChargingStation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAxMUwxMS41IDE3VjEzSDkuNUwxMi41IDdWMTFIMTQuNVpNNyAxSDE3QzE4LjEgMSAxOSAxLjkgMTkgM1YyMUMxOSAyMi4xIDE4LjEgMjMgMTcgMjNIN0M1LjkgMjMgNSAyMi4xIDUgMjFWM0M1IDEuOSA1LjkgMSA3IDFaTTcgNlYxOEgxN1Y2SDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChargingStation = createIcon('ChargingStation', [
  [
    'path',
    {
      d: 'M14.5 11L11.5 17V13H9.5L12.5 7V11H14.5ZM7 1H17C18.1 1 19 1.9 19 3V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1ZM7 6V18H17V6H7Z',
      key: 'xfb2o5',
    },
  ],
]);

export default ChargingStation;
